<template>
	<div class="login-form">
		<div class="login-box layui-anim layui-anim-up">
			<div class="login-box-left">
				<div class="box-item"></div>
				<div class="box-title">鄂托克旗融媒体中心智能管理系统</div>
			</div>
			<div class="login-input-view">
				<el-form :model="dataForm" :rules="dataRule" size="medium" ref="dataForm" @keyup.enter.native="dataFormSubmit()" style="width: 356px; margin-top: 60px">
					<div class="title">登录</div>
					<el-col :span="24">
						<el-form-item prop="mobilePhone">
							<el-input v-model="dataForm.mobilePhone" placeholder="请输入帐号"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item prop="password">
							<el-input v-model="dataForm.password" type="password" placeholder="请输入密码" show-password></el-input>
						</el-form-item>
					</el-col>
					<el-button class="login-btn-submit" type="warning" style="width: 100%;"
					@click="dataFormSubmit()"
					:loading="isHttpLoading">
					登录
					</el-button>
				</el-form>
			</div>
		</div>
		<Verify
		ref="verify"
		@success="onVerifySuccess"
		captchaType="blockPuzzle"
		:imgSize="{ width: '330px', height: '155px' }"
		/>
	</div>
</template>
<script>
import {
  SystemController
} from '@/api';
import {
  mapMutations
} from 'vuex';
import projectConfig from '@/core/config';
import {
  encrypt,
  setToken
} from '@/utils';
import Verify from '@/components/Verifition/Verify.vue';

export default {
  components: {
    Verify
  },
  data () {
    return {
      dataForm: {
        mobilePhone: '',
        password: ''
      },
      dataRule: {
        mobilePhone: [{
          required: true,
          message: '帐号不能为空',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '密码不能为空',
          trigger: 'blur'
        }]
      },
      projectName: projectConfig.projectName
    };
  },
  methods: {
    dataFormSubmit () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          this.$refs.verify.show();
        }
      });
    },
    login (verifyParams) {
      let params = {
        loginName: this.dataForm.mobilePhone,
        password: encrypt(this.dataForm.password),
        captchaVerification: (verifyParams || {}).captchaVerification
      };

      SystemController.login(this, params, null, {
        showMask: false
      }).then(data => {
        this.setMenuList(data.data.menuList);
        delete data.data.menuList;

        this.setUserInfo(data.data);
        setToken(data.data.tokenData);
        this.setCurrentMenuId(null);
        this.$router.replace({
          name: 'main'
        });
      }).catch(e => {});
    },
    onVerifySuccess (verifyParams) {
      this.login(verifyParams);
    },
    ...mapMutations(['setUserInfo', 'setMenuList', 'setCurrentMenuId'])
  },
  mounted () {
    this.setMenuList([]);
    this.setUserInfo({});
    setToken();
  }
};
</script>

<style lang="scss">
	.login-form {
		width: 100vw;
		height: 100vh;
		background: url(../../assets/img/new-login-bg.png);
		background-size: cover;

		.login-box {
			width: 800px;
			height: 420px;
			min-height: 420px;
			max-width: 800px;
			background: url(../../assets/img/login-box-bg.png);
			background-size: cover;
			border-radius: 12px;
			position: fixed;
			top: 50%;//div左上角点位 距离顶部位置
			left: 60%;//div左上角点位 距离左部位置
      margin-left: -300px;//左右距离
      margin-top: -210px;//上下距离
			.login-box-left {
				height: 100%;
				width: 380px;
				float: left;
				padding: 50px 30px;
				.box-item {
					width: 30px;
					height: 3px;
				}
				.box-title{
					color: #fff;
					font-size: 24px;
					margin-top: 20px;
					text-align: center;
				}
			}
			.login-input-view {
				height: 100%;
				width: 420px;
				float: right;
				display: flex;
				align-items: center;
				flex-direction: column;
				.title {
					color: #409EFF;
					font-size: 25px;
					font-weight:bold;
					text-align: center;
					margin: 24px 0px;
				}
			}
		}
	}

	.layui-anim {
		animation-duration: .3s;
		animation-fill-mode: both
	}

	@keyframes layui-up {
		from {
			transform: translate3d(0,100%,0);
			opacity: .6
		}
		to {
			transform: translate3d(0,0,0);
			opacity: 1
		}
	}

	.layui-anim-up {
		animation-name: layui-up
	}

	.login-form .el-input__inner {
		height: 45px !important;
	}

	.login-form .el-button {
		height: 45px !important;
		font-size: 20px;
	}
</style>
